import React, {FunctionComponent, useRef, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import a11yClick from '../../libs/a11y-click';

import styles from './burger-menu.module.css';

const BurgerMenu: FunctionComponent<Record<string, unknown>> = props => {
  const {pathname} = useLocation();
  const menuCheckboxElement = useRef<HTMLInputElement | null>(null);

  // Close the burger menu on location change
  useEffect(() => {
    if (menuCheckboxElement.current) {
      menuCheckboxElement.current.checked = false;
    }
  }, [pathname]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (a11yClick(event)) {
      event.currentTarget.click();
    }
  };

  return (
    <div>
      <input
        ref={menuCheckboxElement}
        id="mobileMenuCheckbox"
        type="checkbox"
        className={styles.menuCheckbox}
      />
      <label
        htmlFor="mobileMenuCheckbox"
        className={styles.menuToggle}
        onKeyDown={handleKeyDown}
        tabIndex={0}>
        <span className={styles.line}></span>
        <span className={styles.line}></span>
        <span className={styles.line}></span>
      </label>
      <div className={styles.menu}>{props.children}</div>
    </div>
  );
};

export default BurgerMenu;
